import { Button as AntdButton, List, Modal } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Person } from '~/types/Person';

interface SharedContactModalProps {
  open: boolean;
  title: string;
  listData: Person[];
  selectedContact: Person | null;
  onCancel: () => void;
  setSelectedContact: (contact: Person) => void;
  handleCreateNewContact: () => void;
  handleSelectContact: () => void;
}

export const MatchingContactsModal: React.FC<SharedContactModalProps> = ({
  open,
  title,
  listData,
  selectedContact,
  onCancel,
  setSelectedContact,
  handleCreateNewContact,
  handleSelectContact,
}) => {
  const { t } = useTranslation('fillApplication');

  return (
    <Modal
      open={open}
      title={title}
      onCancel={onCancel}
      footer={[
        <AntdButton key="newContact" onClick={handleCreateNewContact}>
          {t('Create New Contact')}
        </AntdButton>,
        <AntdButton key="select" type="primary" disabled={!selectedContact} onClick={handleSelectContact}>
          {t('Select')}
        </AntdButton>,
      ]}
    >
      <List
        dataSource={listData}
        renderItem={(item: Person) => (
          <List.Item
            onClick={() => setSelectedContact(item)}
            style={{
              cursor: 'pointer',
              backgroundColor: selectedContact?.contactId === item.contactId ? '#e6f7ff' : 'transparent',
              padding: '8px',
              borderRadius: '4px',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
            }}
          >
            {`Name: ${item.firstName} ${item.lastName}`}
            <br />
            {`Roles: ${item.userRoles?.join(' - ')}`}
          </List.Item>
        )}
      />
    </Modal>
  );
};
